import Popover from "@mui/material/Popover";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import React, {Fragment, useEffect, useState} from "react";
import {InfoBloodmagicItemBehaveSubscriber} from "../_helper/InfoBloodmagicItemBehave";
import {IBloodmagicItemStrainMod, IDataBloodmagicItem} from "../_interfaces/IDataBloodmagicItem";
import {displayMod} from "../_helper/displayMod";
import modTitles from "../Char/Mods/modTitles";
import modsTypes from "../Char/Mods/modTypes";

function BloodMagicItemPopover() {

    const [bloodMagicItem, setBloodMagicItem] = useState<IDataBloodmagicItem | null>(null);
    const [bloodMagicItemAncor, setBloodMagicItemAncor] = useState<HTMLElement | Element | null>(null);
    const [bloodMagicItemOpen, setBloodMagicItemlOpen] = useState(false);

    useEffect(() => {
        const subscription = InfoBloodmagicItemBehaveSubscriber.subscribe((newValue) => {
            setBloodMagicItem(newValue.pop);
            setBloodMagicItemAncor(newValue.popEl)
            setBloodMagicItemlOpen(newValue.popOpen)
        });

        return () => {
            subscription.unsubscribe();
        };
    }, []);

    const handleClose = () => {
        setBloodMagicItemAncor(null)
        setBloodMagicItem(null)
        setBloodMagicItemlOpen(false);
    }

    const modDur = (mod: IBloodmagicItemStrainMod) => {
        if (mod?.duration > 0) {
            const type = modsTypes.find(t => t.key === mod.type)
            if (type) {
                if (type.dur) return 'für '+ mod.duration + " " +type.name;
                else return type.name;
            }
        }
        return ''
    }

    const modWhat = (mod: IBloodmagicItemStrainMod) => {
        if (modTitles[mod.what]) return modTitles[mod?.what]
        else return ''
    }

    if (bloodMagicItemOpen && bloodMagicItem) return <Popover
        open={bloodMagicItemOpen}
        anchorEl={bloodMagicItemAncor}
        onClose={handleClose}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
        }}
    >
        <Grid container spacing={1} style={{padding: 10}}>
            <Grid item xs={10}>
                {bloodMagicItem?.name}
            </Grid>
            <Grid item xs={2}>
                <Button onClick={() => handleClose()}>X</Button>
            </Grid>
            <Grid item xs={12}>
                <div>Beschreibung:</div>
                <div>{bloodMagicItem?.desc.map(d=><div>{d}</div>)}</div>
            </Grid>
            <Grid item xs={12}>
                <div>Blutschaden: {bloodMagicItem?.dmg}</div>
            </Grid>
            <Grid item xs={12}>
                <div>Überanstrengung: {bloodMagicItem?.strain}</div>
            </Grid>
            {bloodMagicItem && bloodMagicItem.strain_mods ? <Grid item xs={12}>
                <div>Effekte:</div>
                <ul>
                    {bloodMagicItem.strain_mods.map(mod => <li>
                        {displayMod(mod?.mod)} {modWhat(mod)} {modDur(mod)}
                    </li>)}
                </ul>
            </Grid> : null}
            <Grid item xs={12}>
                <div>Verfügbarkeit: {bloodMagicItem?.avail}</div>
            </Grid>
        </Grid>
    </Popover>

    return <Fragment/>
}

export default BloodMagicItemPopover;